module.exports = { default: Vue };